var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyGridState = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty state"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM7 19.3571H15.5V23H8C7.44772 23 7 22.5523 7 22V19.3571ZM7 18.3571H15.5V14.7857H7V18.3571ZM16.5 23V19.3571H25V22C25 22.5523 24.5523 23 24 23H16.5ZM16.5 18.3571H25V14.7857H16.5V18.3571ZM26 18.8571V18.3571V14.7857V14.2857V13.7857V10C26 8.89543 25.1046 8 24 8H8C6.89543 8 6 8.89543 6 10V13.7857V14.2857V14.7857V18.3571V18.8571V19.3571V22C6 23.1046 6.89543 24 8 24H15.5H16H16.5H24C25.1046 24 26 23.1046 26 22V19.3571V18.8571ZM25 10V13.7857H16H7V10C7 9.44771 7.44771 9 8 9H24C24.5523 9 25 9.44772 25 10Z",
    fill: "#F4F5FA"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyGridState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-grid-state.67076db7aed17f3ca0f182f61386fdcc.svg";